'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

export const TermsOfService: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="legal-page">
            <Helmet>
                <title>{t('terms.title')}</title>
            </Helmet>
            <div className="container">
                <div className="legal-card">
                    <h1 className="legal-title">{t('terms.title')}</h1>
                    <p className="legal-meta">{t('terms.updated')}</p>

                    <section className="legal-section">
                        <h3>{t('terms.section1.title')}</h3>
                        <p>{t('terms.section1.body')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('terms.section2.title')}</h3>
                        <p>{t('terms.section2.body')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('terms.section3.title')}</h3>
                        <p>{t('terms.section3.body')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('terms.section4.title')}</h3>
                        <p>{t('terms.section4.body')}</p>
                    </section>
                </div>
            </div>
        </div>
    );
};
